import React from "react";
import {
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import "./styles.css";
import { Row, Col } from "antd";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};
function CardSection() {
  return (
    <div className="tiles padding-12 w-100">
      <span className="col-label">Card Information</span>
      <Row className="mt-2">
        <Col span={24} className="mb-2">
          <CardNumberElement options={CARD_ELEMENT_OPTIONS} />
        </Col>

        <Row className="mb-2 w-100">
            <Col span={12} className="pr-2">
            <CardExpiryElement options={CARD_ELEMENT_OPTIONS} />
            </Col>
            <Col span={12}>
            <CardCvcElement options={CARD_ELEMENT_OPTIONS} />
            </Col>
        </Row>
      </Row>
    </div>
  );
}
export default CardSection;
